<section class="faq-section">
    <div class="container">
        <h2>
            MyLifeWell FAQs
        </h2>
        <ul class="faq-list">
            <li class="faq-cate-title">
                <h2>
                    App
                </h2>
            </li>
            <li class="accordian" (click)="accordianChange(0)">
                <h3>
                    MyLifeWell App Tour - Features, Tips and Tricks.
                    <span class="plus-wrap"></span>
                </h3>
                <div class="faq-content">
                    <p class="space-less">
                    </p>
                </div>
            </li>
            <li class="faq-cate-title">
                <h2>General</h2>
            </li>
            <li class="accordian" (click)="accordianChange(1)">
                    <h3>How is MyLifeWell different than other wellness platforms?
                        <span class="plus-wrap"></span>
                    </h3>
                    <div class="faq-content">
                    <p><strong>Comprehensive: </strong> You probably had to do a lot of Google searches to find the rightfitness classes, instructors, travel or products and you likely have memberships with each one. With MyLifeWell, all you need is ONE membership and you can have your virtual programs, active and wellness travel and wellness products all in ONE place. 
                    </p>
                    <p class="faq-content"><strong>Variety: </strong> That ONE membership doesn’t mean you only get fitness classes, it means you get to choose from a variety of yoga, fitness, nutrition, mindfulness, meditation, healing therapies, relationship therapy, stress management and more. Try something different each day and who knows, you may find a new passion! </p>
                    <p class="faq-content"><strong>Quality: </strong> We vet our partners to ensure that they meet our high standards and do the research for you to make sure the information, training and trips you take are of the highest quality. Take yoga from the masters at Ananda in the Himalayasor learn about weight loss from the experts at Pritikin Longevity Center or join in on a fitness class from Carillon Miami Wellness Center.</p>
                    <p class="faq-content"><strong>Support: </strong> You can add the services of a Wellness Coach to help support you in achieving your wellness goals or a Wellness Travel Advisor to guide you to the right trip and take care of all the pesky details you don’t have time to manage (can anyone really keep up with Covid restrictions or places that are open for visitors?). </p>
                    <!-- <p class="space-less">
                        Take advantage of our 
                        <a *ngIf="globalServices.isLoggedIn" href="/myaccount"> offers </a>
                        <a *ngIf="!globalServices.isLoggedIn" href="/subscription"> offers </a> 
                        to experience the difference for yourself.
                    </p> -->
                    </div>
            </li>
            <li class="accordian" (click)="accordianChange(2)">
                <h3>What’s your cancellation policy?
                    <span class="plus-wrap"></span>
                </h3>
                <div class="faq-content">
                <p><strong>Subscriptions: </strong> If you have a monthly subscription, you can cancel at any time and your subscription will end at the end of the billing cycle. If you have an annual subscription, you can make changes at the end of the subscription year. 
                </p>
                <p class="space-less"><strong>Travel, products & digital Offerings: </strong> We abide by the cancellation policies of our partners who are providing the programs, services and products. Each course, trip or product you select will clearly state the cancellation policy from that provider on the information page. </p>
                
                </div>
        </li>
        <li class="accordian" (click)="accordianChange(3)">
            <h3>What’s your Privacy Policy?
                <span class="plus-wrap"></span>
            </h3>
            <div class="faq-content">
            <p class="space-less">We take your privacy very seriously. We promise not to rent, sell or trade your personal information. You can learn more about our <a href="/privacy_policy"> Privacy Policy</a>.
            </p>
            </div>
    </li>
    <li class="accordian" (click)="accordianChange(4)">
        <h3>What’s available now and what’s coming soon on MyLifeWell?
            <span class="plus-wrap"></span>
        </h3>
        <div class="faq-content">
        <p class="space-less">You can take advantage of all our virtual classes and programs available under the Live Well section. We will keep adding new classes and programs every month going forward. You can also explore active and wellness travel packages from the leading resorts and tour operators around the world via the Travel Well section. The Shop Well section will go live in March, 2021.
        </p>
        </div>
    </li>
    <li class="accordian" (click)="accordianChange(5)">
        <h3>Does MyLifeWell have an app? 
            <span class="plus-wrap"></span>
        </h3>
        <div class="faq-content">
        <p class="space-less">We have an app in the works that will be available soon. In the meantime, explore our mobile friendly platform through your browser.</p>
        </div>
    </li>
    <li class="accordian" (click)="accordianChange(6)">
        <h3>Do you have a loyalty program?
            <span class="plus-wrap"></span>
        </h3>
        <div class="faq-content">
        <p class="space-less">Yes! You can earn points for every dollar you spend on MyLifeWell, regardless of whether it’s from the virtual programs, travel or shop. The points you earn are based on the subscription level you select - Wellness Explorers earn 1 point/$1 spent across the platform, Wellness Enthusiasts earn 2 points/$1 spent across the platform and Wellness Devotees earn 3 points/$1 spent across the platform. In addition, the Wellness Coach and Wellness Travel Advisor options both offer 2 points earned/$1 spent across the platform.</p>
        </div>
    </li>
    <li class="accordian" (click)="accordianChange(7)">
        <h3>How do I redeem my loyalty points?
            <span class="plus-wrap"></span>
        </h3>
        <div class="faq-content">
        <p class="space-less">You can redeem your loyalty points for any products or packages available on the platform. We’ll soon offer the ability to redeem your points outside the platform through gift cards. So go ahead and do something good for yourself on MyLifeWell and then pick the reward that you enjoy the most be it buying move tickets or dining at your favorite restaurant or shopping at Amazon!</p>
        </div>
    </li>
    <li class="faq-cate-title">
        <h2>Live Well</h2>
    </li>
    <li class="accordian" (click)="accordianChange(8)">
        <h3>What type of programs are on MyLifeWell?
            <span class="plus-wrap"></span>
        </h3>
        <div class="faq-content">
            <p class="space-less">We offer a wide variety of programming to cover the gamut of health and wellness: nutrition, fitness, yoga, mindfulness, energy healing, stress management, financial management, anxiety, sleep and more. We’ll continue to add programs as we see the need arise. </p>
        </div>
    </li>
    <li class="accordian" (click)="accordianChange(9)">
        <h3>When will the virtual programs be available?
            <span class="plus-wrap"></span>
        </h3>
        <div class="faq-content">
            <p class="space-less">The virtual wellness programs will be available in early November.</p>
        </div>
    </li>
    <li class="accordian" (click)="accordianChange(10)">
        <h3>Do I need a lot of equipment to work out? 
            <span class="plus-wrap"></span>
        </h3>
        <div class="faq-content">
            <p class="space-less">It depends on the class you select. There are many classes that use your body weight and no special equipment while others suggest having small weights or kettlebells to be the most effective. </p>
        </div>
    </li>
    <li class="accordian" (click)="accordianChange(11)">
        <h3>Do I have to be experienced to do the classes?  
            <span class="plus-wrap"></span>
        </h3>
        <div class="faq-content">
            <p class="space-less">Not at all. Our experts have developed programs that guide you whether it’s your first time or you workout all the time. Start with where you’re at and build up from there, you’ll be surprised at how quickly you learn and grow.</p>
        </div>
    </li>
    <li class="accordian" (click)="accordianChange(12)">
        <h3>I don’t have a lot of time, how long are the classes?  
            <span class="plus-wrap"></span>
        </h3>
        <div class="faq-content">
            <p class="space-less">Time shouldn’t determine the quality of your experience. We have meditations from 5 minutes to hour long fitness and nutrition classes. Start with the time you have and add on when you’re able. It’s not an all or none approach, it’s about taking the first step.</p>
        </div>
    </li>
    <li class="accordian" (click)="accordianChange(13)">
        <h3>What does a Wellness Coach do?
            <span class="plus-wrap"></span>
        </h3>
        <div class="faq-content">
            <p class="space-less">If you don’t know where to start or have a specific health goal in mind, our wellness coaches can help you put together a plan based on your needs. They can then recommend the right programs and products, support and motivate you on your journey to better health. 
                <!-- Learn more about our 
                <a *ngIf="globalServices.isLoggedIn" href="/myaccount"> 
                    Wellness Coach package
                </a>
                <a *ngIf="!globalServices.isLoggedIn" href="/subscription">
                    Wellness Coach package
                </a>
                and the offers. -->
            </p>
        </div>
    </li>
    <!-- <li class="faq-cate-title">
        <h2>Travel Well</h2>
    </li>
    <li class="accordian" (click)="accordianChange(14)">
        <h3>What is Wellness Travel?
            <span class="plus-wrap"></span>
        </h3>
        <div class="faq-content">
            <p>Wellness travel isn’t just about yoga and meditation. It’s travel that allows you to maintain, enhance or kick-start a healthy lifestyle, and support or increase your sense of wellbeing.Here’s a sample:</p>
            <p><strong>Active Trips: </strong> Get out and move! Choose hiking, biking, white water rafting, golf, tennis surfing or whatever activity gets your blood flowing.</p>
            <p><strong>Single Focus: </strong> There are times when you want to hone in on a specific intention. Whether it’s challenges of weight loss or sleep issues or anti-aging, these are programs that solve a particular need.</p>
            <p><strong>Spiritual/Transformational: </strong> Are you looking for your Eat, Pray, Love journey? These trips help you get in touch with your higher self. Whether you’re in the presence of the monks in Bhutan or the Shamans in Mexico, you’ll be seeking, learning and growing.</p>
            <p class="space-less"><strong>Rest & Relaxation: </strong> If you’re stressed out and burned out, you may just need a reset. Relax in the serenity of the mountains or by the turquoise waters of a tropical island. This is your “do nothing” holiday.</p>
            
        </div>
    </li>
    <li class="accordian" (click)="accordianChange(15)">
        <h3>What does a Wellness Travel Advisor do?
            <span class="plus-wrap"></span>
        </h3>
        <div class="faq-content">
            <p class="space-less">If you need some help finding the right trip, navigating through the Covid restrictions, understanding trip insurance (or why you would want it), or customizing the trip for your friends, family or team, you’ll benefit from the services of our expert Wellness Travel Advisors.
                Learn more about our
                <a *ngIf="globalServices.isLoggedIn" href="/myaccount">
                    Travel Advisor package
                </a>
                <a *ngIf="!globalServices.isLoggedIn" href="/subscription">
                    Travel Advisor package
                </a> 
                and the offers
            </p>
        </div>
    </li>
    <li class="accordian" (click)="accordianChange(16)">
        <h3>What if I have questions before I book?
            <span class="plus-wrap"></span>
        </h3>
        <div class="faq-content">
            <p class="space-less">If you need more information or have specific questions about a trip, you can ask the retreat or resort directly. Click on “Send Enquiry” in the right hand corner of the trip page, below the pricing. Enter a subject and your questions and the provider will get back to you within 48 hours.</p>
        </div>
    </li>
    <li class="accordian" (click)="accordianChange(17)">
        <h3>How do I book a trip?
            <span class="plus-wrap"></span>
        </h3>
        <div class="faq-content">
            <p class="space-less">Search for exactly what you want or explore the site to find a trip that suits your style. The trip page will give you all the information you need, from the activities to the accommodations to what’s included to cancellation policies. Once you’re ready to book, click the “Book Reservation” button and the retreat or resort will verify availability. The retreat or resort may take up to48 hours to confirm your spot after which your card will be charged for the deposit listed on the package. If for some reason the trip is full, you’ll get an email letting you know and suggesting an alternate option.</p>
        </div>
    </li>
    <li class="accordian" (click)="accordianChange(18)">
        <h3>Do you have trips for solo travelers or for my girls’ getaway?
            <span class="plus-wrap"></span>
        </h3>
        <div class="faq-content">
            <p class="space-less">We offer trips for individuals, families, couples and groups. Browse the Special Interest section under Wellness Styles to pick from culinary trips to luxury retreats to holiday getaways.</p>
        </div>
    </li>
    <li class="accordian" (click)="accordianChange(19)">
        <h3>What if I like a package but I want to customize it for my family or group?
            <span class="plus-wrap"></span>
        </h3>
        <div class="faq-content">
            <p class="space-less">
                If you’re looking for personalized support with trips, which includes customization as well as help with airport transfers, travel insurance, visas and more,
                 we suggest you consider adding on the service of our 
                <a *ngIf="globalServices.isLoggedIn" href="/myaccount">
                     Wellness Travel Advisor
                </a>
                <a *ngIf="!globalServices.isLoggedIn" href="/subscription">
                    Wellness Travel Advisor
                </a>.
                <a *ngIf="!globalServices.isLoggedIn" href="/travel/advisor">
                    Wellness Travel Advisor
                </a>.
                
                Our experts will take care of all the details so all you have to do is show up and enjoy the journey!</p>
        </div>
    </li>
    <li class="accordian" (click)="accordianChange(20)">
        <h3>Will your trips fit into my budget? 
            <span class="plus-wrap"></span>
        </h3>
        <div class="faq-content">
            <p class="space-less">Our goal is accessibility. Whether you want a tented camp, a boutique retreat or a luxury escape, we’ve got something to fit your style and your budget. We have trips from the brands you know and love as well as retreats hidden in beautiful corners of the world.</p>
        </div>
    </li> -->
    <!-- <li class="faq-cate-title">
        <h2>Shop Well</h2>
    </li>
    <li class="accordian" (click)="accordianChange(21)">
        <h3>When will I be able to buy products from MyLifeWell? 
            <span class="plus-wrap"></span>
        </h3>
        <div class="faq-content">
            <p class="space-less">
                We’ll be adding our wellness products by the end of the year. Stay tuned for more updates!
            </p>
        </div>
    </li> -->
    
    </ul>
    </div>
</section>
